module.exports = __webpack_public_path__ + "static/media/WorkAccident.9fd590ab.svg";